import { render } from "./MyAccount.vue?vue&type=template&id=19bcd4c4&lang=pug"
import script from "./MyAccount.vue?vue&type=script&lang=ts"
export * from "./MyAccount.vue?vue&type=script&lang=ts"

import "./MyAccount.vue?vue&type=style&index=0&id=19bcd4c4&lang=scss"
script.render = render

export default script